'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.default = HTMLComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _server = require('react-dom/server');

var _server2 = _interopRequireDefault(_server);

var _serializeJavascript = require('serialize-javascript');

var _serializeJavascript2 = _interopRequireDefault(_serializeJavascript);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HTMLComponent(_ref) {
  var appConfig = _ref.appConfig,
      _ref$bodyClass = _ref.bodyClass,
      bodyClass = _ref$bodyClass === undefined ? '' : _ref$bodyClass,
      assets = _ref.assets,
      component = _ref.component,
      store = _ref.store,
      i18n = _ref.i18n,
      stylesheet = _ref.stylesheet;

  var content = component ? _server2.default.renderToString(component) : '';
  var head = !__TEST__ && _reactHelmet2.default.rewind();

  return _react2.default.createElement(
    'html',
    { lang: 'en' },
    _react2.default.createElement(
      'head',
      null,
      head && head.base.toComponent(),
      head && head.title.toComponent(),
      head && head.meta.toComponent(),
      head && head.link.toComponent(),
      head && head.script.toComponent(),
      _react2.default.createElement('meta', { name: 'viewport', content: 'width=device-width, initial-scale=1' }),
      (0, _keys2.default)(assets.styles).map(function (style, key) {
        return _react2.default.createElement('link', {
          href: assets.styles[style],
          key: key,
          media: 'screen, projection',
          rel: 'stylesheet',
          type: 'text/css',
          charSet: 'UTF-8'
        });
      }),
      (0, _keys2.default)(assets.styles).length === 0 ? _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: stylesheet } }) : null
    ),
    _react2.default.createElement(
      'body',
      { className: bodyClass },
      _react2.default.createElement('div', { id: 'content', dangerouslySetInnerHTML: { __html: content } }),
      _react2.default.createElement('script', {
        dangerouslySetInnerHTML: { __html: 'window.__data=' + (0, _serializeJavascript2.default)(store.getState()) + ';' },
        charSet: 'UTF-8'
      }),
      _react2.default.createElement('script', {
        dangerouslySetInnerHTML: { __html: 'window.__locale=\'' + i18n.language + '\'' },
        charSet: 'UTF-8'
      }),
      _react2.default.createElement('script', {
        dangerouslySetInnerHTML: { __html: 'window.__appConfig=\'' + (0, _serializeJavascript2.default)(appConfig) + '\'' },
        charSet: 'UTF-8'
      }),
      _react2.default.createElement('script', { src: assets.javascript.main, charSet: 'UTF-8' })
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/chemist/dist/middleware/rendering/HTMLComponent.js
// module id = 649
// module chunks = 0